import React, {useEffect} from "react";
import {IWorkspaceItem} from "../../models/Workspace";
import {useEstimateProductBundlePriceCostMutation} from "../../store/endpoints/ProductBundleEndpoints";
import {ActionButton, Spinner, SpinnerSize, TooltipHost, useTheme} from "@fluentui/react";

interface IBundleInStockDisplayProps {
    item: IWorkspaceItem;
    refreshing?: boolean;
    /** When the bundle cannot be sourced, offers the prepared-cart "include anyway" override on the line. */
    onIncludeAnyway?: () => void;
}

export const BundleInStockDisplay: React.FC<IBundleInStockDisplayProps> = (props) => {
    const theme = useTheme();

    const [getEstimate] = useEstimateProductBundlePriceCostMutation()
    const [maxQuantity, setMaxQuantity] = React.useState(0);
    const [fetching, setFetching] = React.useState(true);

    useEffect(() => {
        if (props.item && props.item.isBundle && props.item.sourceEntityId) {
            setFetching(true);
            getEstimate({bundleId: props.item.sourceEntityId, request: {}}).unwrap().then(a => {
                if (a) {
                    setMaxQuantity(a.maxQuantity ?? 0);
                    setFetching(false);
                }
            }).catch(() => setFetching(false));
        }
    }, [props.item]);

    if (fetching) return <Spinner size={SpinnerSize.small}/>;
    
    if (maxQuantity && maxQuantity > 0) {
        return (<div className="in-stock-dense">
            <div
                style={{
                    width: '100%',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                }}
            >
                Stock{maxQuantity < 9999 && <><br/>{`(${maxQuantity})`}</>}
            </div>
        </div>);
    }

    return (
        <div>
            <div className="no-stock-dense" style={{color: props.refreshing ? 'grey' : '#dd1919ff'}}>
                No Stock
            </div>
            {props.onIncludeAnyway && props.item.details?.alwaysAvailable !== true &&
                <TooltipHost content="This bundle can't be sourced right now, so a prepared cart would skip it. Include it anyway; the Always Included pill undoes this.">
                    <ActionButton
                        iconProps={{iconName: 'Accept'}}
                        styles={{root: {height: 24, padding: 0, color: theme.palette.themePrimary}, icon: {fontSize: 12, color: theme.palette.themePrimary}, label: {fontSize: 12, fontWeight: 600}}}
                        onClick={props.onIncludeAnyway}
                    >
                        Include anyway
                    </ActionButton>
                </TooltipHost>}
        </div>)
}
